
const gwsDialog = {
  state: {
    gwsState: false,
    gwsArr: []  // [{id: '', label: ''}]
    // bmsIds: '',
    // bmsNames: ''
  },

  mutations: {
    SET_GWSSTATE: (state, val) => {
      state.gwsState = val
      console.log(state)
    },
    SET_GWSARR: (state, val) => {
      state.gwsArr = JSON.parse(JSON.stringify(val))
    }
  },

  actions: {
    
  }
}

export default gwsDialog
